<template>
    <div>
        <a-spin :spinning="exportLoading">
            <div v-if="!showDetails" class="smart-wiring-list">
                <page-container>
                    <a-form-model :colon="false" :model="queryForm" layout="inline" class="form wiring_form">
                        <div class="search-form">
                            <a-form-model-item label="计划单名称">
                                <a-input v-model="queryForm.planName" class="w-224" allowClear placeholder="请输入计划单名称" :max-length="100" @pressEnter="toSearch" />
                            </a-form-model-item>
                            <a-form-model-item label="创建时间">
                                <a-range-picker v-model="createTime" class="w-224" :show-time="showTime" format="YYYY.MM.DD HH:mm" @ok="handleOk" @change="handleTimeChange">
                                    <template #suffixIcon>
                                        <a-icon type="calendar" />
                                    </template>
                                </a-range-picker>
                            </a-form-model-item>

                            <a-form-model-item label="平衡状态">
                                <a-select ref="select" v-model="queryForm.loadBalanceType" allowClear placeholder="请选择" class="w-224" style="width: 120px;">
                                    <a-select-option value="BEFORE">平衡前</a-select-option>
                                    <a-select-option value="AFTER">平衡后</a-select-option>
                                </a-select>
                            </a-form-model-item>

                            <div class="form-btn">
                                <a-button @click="handleReset">重置</a-button>
                                <a-button type="primary" @click="toSearch">查询</a-button>
                            </div>
                        </div>
                    </a-form-model>
                </page-container>
                <a-divider class="line" />
                <page-container class="list-table">
                    <!-- <div class="flex">
                        <a-button v-track-click="{ trackName: '智能排线-导入计划单' }" class="create-plus marRight16" type="primary" @click="addTemplate">
                            <img src="@/assets/img/icon_daorujhd_new.png" alt />
                            导入计划单
                        </a-button>
                    </div> -->
                    <a-table
                        :columns="tableColumns"
                        :data-source="dataList"
                        :loading="dataListLoading"
                        :pagination="pagination"
                        :scroll="{ x: 'calc(700px + 50%)' }"
                        class="goods-table table-multip"
                        row-key="id"
                        @change="tableChange"
                    >
                        <template slot="planName" slot-scope="text, record">
                            <a-tooltip placement="top">
                                <template slot="title">
                                    <span>{{ text }}</span>
                                </template>

                                <!-- 已超时，待排线均不能点击-->
                                <div v-if="[PLAN_STATUS.TO_BE_PLAN, PLAN_STATUS.OVERTIME, PLAN_STATUS.SCHEDULE_ERROR, PLAN_STATUS.PUSH_FAILED].includes(record.status)" class="plan_text ellipsis">
                                    {{ conductLength(text) }}
                                </div>
                                <div v-else type="link" class="plan-name ellipsis" @click="toDetail(record)">
                                    {{ conductLength(text) }}
                                </div>
                            </a-tooltip>
                        </template>

                        <template slot="status" slot-scope="text, record">
                            <span :class="record.isDraft ? ['default'] : ['default', statusType(text)]">{{ record.isDraft ? '草稿' : PLANSTATUSEMU[text] || '--' }}</span>
                        </template>
                        <template slot="loadFactorApproveStatus" slot-scope="text, { planMsgApprove }">
                            <span style="display: block">{{ PLANSTATUSRESULTEMU[text] || '--' }}</span>
                            <a-tooltip>
                                <template slot="title">
                                    {{ createApproveResult(planMsgApprove, 0) }}
                                </template>
                                <span>{{ substring(createApproveResult(planMsgApprove, 0), 12) }}</span>
                            </a-tooltip>
                        </template>
                        <template slot="expenseVarianceApproveStatus" slot-scope="text, { planMsgApprove }">
                            <span style="display: block">{{ PLANSTATUSRESULTEMU[text] || '--' }}</span>
                            <a-tooltip>
                                <template slot="title">
                                    {{ createApproveResult(planMsgApprove, 1) }}
                                </template>
                                <span>{{ substring(createApproveResult(planMsgApprove, 1), 12) }}</span>
                            </a-tooltip>
                        </template>
                        <template slot="msgPlanModifyApproveStatus" slot-scope="text, { planMsgApprove }">
                            <span style="display: block">{{ PLANSTATUSRESULTEMU[text] || '--' }}</span>
                            <a-tooltip>
                                <template slot="title">
                                    {{ createApproveResult(planMsgApprove, 2) }}
                                </template>
                                <span>{{ substring(createApproveResult(planMsgApprove, 2), 12) }}</span>
                            </a-tooltip>
                        </template>
                        <template slot="result" slot-scope="text, record">
                            <p v-if="record.status === PLAN_STATUS.TO_BE_PLAN" class="ellipsis2">
                                正在进行排线计算,请等待...
                            </p>
                            <p v-else-if="record.status === PLAN_STATUS.OVERTIME" class="ellipsis2">
                                排线超时，请联系管理员或重试
                            </p>
                            <p v-else-if="record.status === PLAN_STATUS.IMPORT_FAILED" class="ellipsis2">
                                {{ record.result }}
                            </p>
                            <p v-else class="ellipsis2" v-html="result(text)" />
                        </template>
                        <template slot="createUser" slot-scope="text, record">
                            <p class="ellipsis1">{{ text }}</p>
                            <p>{{ record.createUserAccount }}</p>
                        </template>
                        <template slot="action" slot-scope="text, record">
                            <!-- <span v-if="record.status === PLAN_STATUS.IMPORT_FAILED" class="action-btn">
                                <a :href="record.failedFile" download="错误原因.xlsx">下载错误原因</a>
                            </span>
                            <span
                                v-if="record.status !== PLAN_STATUS.TO_BE_PLAN && record.status !== PLAN_STATUS.OVERTIME && record.status !== PLAN_STATUS.IMPORT_FAILED"
                                class="action-btn"
                                @click="downLoad(record)"
                                >下载排线
                            </span> -->

                            <span
                                v-if="
                                    record.status !== PLAN_STATUS.TO_BE_PLAN &&
                                        record.status !== PLAN_STATUS.OVERTIME &&
                                        record.status !== PLAN_STATUS.IMPORT_FAILED &&
                                        record.status !== PLAN_STATUS.SCHEDULE_ERROR &&
                                        record.status !== PLAN_STATUS.PUSH_FAILED
                                "
                                class="action-btn"
                                @click="toDetail(record)"
                                >查看详情</span
                            >
                            <span v-else class="action-btn-dis">
                                查看详情
                            </span>

                            <span v-if="record.loadBalanceType !== 'BEFORE'" class="action-btn">
                                <span v-if="record.planDraftStatus == 'NOT_GENERATED' && record.status == 'CONFIRMED'" @click="createShippingDraft(record)">创建派车单草稿</span>
                                <span v-else class="action-btn-dis">创建派车单草稿</span>
                            </span>
                            <span v-else class="action-btn-dis">创建派车单草稿</span>
                            <!-- <span class="action-btn" @click="toHistory(record)">历史版本</span> -->

                            <!-- 未确认状态可删除,已超时 -->
                            <!-- <span v-if="[PLAN_STATUS.TO_BE_CONFIRMED, PLAN_STATUS.OVERTIME, PLAN_STATUS.IMPORT_FAILED].includes(record.status)" class="action-btn delete_btn" @click="toDelete(record)"
                                >删除</span
                            > -->
                        </template>
                        <template slot="planAction" slot-scope="text, record">
                            <!-- 状态为“待排线”时不展示 -->
                            <span v-if="record.status === 'IMPORT_FAILED'" class="action-btn">
                                <a :href="record.failedFile" download="错误原因.xlsx">下载错误原因</a>
                            </span>
                            <span
                                v-if="record.status !== PLAN_STATUS.TO_BE_PLAN && record.status !== PLAN_STATUS.OVERTIME && record.status !== PLAN_STATUS.IMPORT_FAILED"
                                class="action-btn"
                                @click="toEdit(record)"
                                >修改计划</span
                            >
                            <span
                                v-if="record.status !== PLAN_STATUS.TO_BE_PLAN && record.status !== PLAN_STATUS.OVERTIME && record.status !== PLAN_STATUS.IMPORT_FAILED"
                                class="action-btn"
                                @click="toDetail(record)"
                                >查看详情</span
                            >
                            <span class="action-btn" @click="toHistory(record)">历史版本</span>
                            <span v-if="!record.loadFactorIsRight" class="action-btn" @click="toApply(record)">满载率不达标申请</span>
                            <span v-if="record.isExistsExpenseVariance" class="action-btn" @click="toDiffInCost(record)">费用差申请</span>
                            <a-popover v-if="record.isDraft && record.status !== PLAN_STATUS.OVERTIME" placement="bottom" :width="200" trigger="hover">
                                <template #content>
                                    <p class="action-btn-popover" :class="['default await']" @click="toBeconfirm(record)">
                                        待确认
                                    </p>
                                </template>
                                <span class="action-btn">状态变更</span>
                            </a-popover>
                            <!-- 超时可删除 -->
                            <span v-if="[PLAN_STATUS.OVERTIME, PLAN_STATUS.IMPORT_FAILED].includes(record.status)" class="action-btn delete_btn" @click="toDelete(record)">删除</span>
                        </template>
                    </a-table>
                </page-container>
                <import-plan ref="importPlan" @cancel="handleCancel" />
                <edit-plan ref="editPlan" @cancel="toSearch" />
                <plan-history ref="planHistory" />
                <edit-confirm ref="editConfirm" @changeEdit="changeEdit" />
                <apply-confirm ref="applyConfirm" :is-planning="isPlanning" />
                <diffInCost-confirm ref="diffInCostConfirm" :is-planning="isPlanning" />
            </div>
            <SmartWiringDetail v-else :plan-code="selectedPlanCode" :plan="selectedPlan" @on-close-details="showDetails = false" />
        </a-spin>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import store from '@/store/index';
import PageContainer from '@/components/page-contanier/index.vue';
import https from '@/utils/http.js';
import { setAppToken, setAppClientCode, getAppClientCode } from '@/utils/auth';
import { getConfig } from '@/pages/orderManage/api';
import { tableColumns, planTableColumns, PLAN_STATUS, PLANSTATUSEMU, PLANSTATUSRESULTEMU } from './const';
import ImportPlan from './component/importPlan.vue';
import { getPlanPage, planLineDelete, statusToBeConfirmed, getInboundPlanPage, createShippingDraft } from '../api';
import EditPlan from './component/editPlan.vue';
import PlanHistory from './component/planHistory.vue';
import EditConfirm from './component/editConfirm.vue';
import ApplyConfirm from './component/ApplyConfirm.vue';
import DiffInCostConfirm from './component/DiffInCostConfirm.vue';
import SmartWiringDetail from '../detail';

export default {
    name: 'CustomImport',
    components: {
        ImportPlan,
        PageContainer,
        EditPlan,
        PlanHistory,
        EditConfirm,
        ApplyConfirm,
        DiffInCostConfirm,
        SmartWiringDetail
    },
    data() {
        return {
            appClientCode: null,
            dataList: [],
            dataListLoading: false,
            tableColumns,
            planTableColumns,
            PLAN_STATUS,
            PLANSTATUSEMU,
            PLANSTATUSRESULTEMU,
            queryForm: {},
            createTime: [],
            showTime: {
                format: 'HH:mm:ss',
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
            },
            pagination: {
                current: 1,
                total: 0,
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                onShowSizeChange: (current, pageSize) => {
                    this.pagination.pageSize = pageSize;
                },
                showQuickJumper: true,
                showTotal: (total) => `共 ${total} 条`
            },
            isIfame: false,
            isPlanning: false, // 计划部门角色
            isLineUpkeep: false,
            loopTimer: null, // 循环更新页面的定时器
            selectedPlanCode: '', // 选中的planCode
            showDetails: false, // 是否显示详情模块
            exportLoading: false,
            selectedPlan: null
        };
    },
    computed: {
        conductLength() {
            return (text) => {
                return text.length > 20 ? `${text.substring(0, 19)}...` : text;
            };
        },
        ...mapState('setting', ['isMobile', 'systemName', 'layout']),
        result() {
            return (text) => {
                if (text) {
                    const splitText = text.split(',');
                    return `${splitText[0]},成功<span style="color:#06b880">${splitText[1].slice(2, -1)}</span>条,失败<span style="color:#FF523C">${splitText[2].slice(2, -1)}</span>条`;
                }
                return '--';
            };
        },
        statusType() {
            return (status) => {
                if (status === PLAN_STATUS.TO_BE_PLAN || status === PLAN_STATUS.TO_BE_CONFIRMED) {
                    return 'await';
                }
                if (status === PLAN_STATUS.CONFIRMED) {
                    return 'success';
                }
                if (status === PLAN_STATUS.PUSH_FAILED || status === PLAN_STATUS.SCHEDULE_ERROR) {
                    return 'danger';
                }
                return '';
            };
        }
    },
    created() {
        // TODO 20230207调整模块结构之后待确认是否需要修改此处路由地址
        // 如果是嵌入的页面，需要取apptoken
        if (this.$route.path === '/otmsSmartWiring') {
            this.isIfame = true;
            const { appToken, appClientCode, accountName, accountId, mobile, customerCode, tenantId, userId } = this.$route.query;
            if (appToken) {
                setAppToken(appToken);
            }
            if (appClientCode) {
                setAppClientCode(appClientCode);
                this.appClientCode = appClientCode;
            }
            if (accountId) {
                store.commit('user/SET_ACCOUNTID', accountId); // 账号id
            }
            if (accountName) {
                store.commit('user/SET_ACCOUNTNAME', accountName); // 组织名称
            }
            if (mobile) {
                store.commit('user/SET_MOBILE', mobile); // 组织名称
            }
            if (customerCode) {
                store.commit('user/SET_CUSTOMER_CODE', customerCode); // 货主编码
            }
            if (userId) {
                store.commit('user/SET_USER_ID', userId); // 货主编码
            }
            if (tenantId) {
                store.commit('user/SET_TENANT_ID', tenantId); // 租户编码
            }
        }
        // this.getConfig();
        this.getList();
    },
    mounted() {
        this.loopTimer = setInterval(() => {
            this.getList(true);
        }, 10000);
    },
    beforeDestroy() {
        clearInterval(this.loopTimer);
        this.loopTimer = null;
    },
    methods: {
        async createShippingDraft(row) {
            this.dataListLoading = true;
            try {
                await createShippingDraft({ id: row.id });
                this.dataListLoading = false;
                this.getList();
            } catch {
                this.dataListLoading = false;
            }
        },
        async getConfig() {
            const res = await getConfig({
                appId: '1002',
                keys: ['starbucks.planning.white.list']
            });
            const { mobile } = this.$store.state.user;
            const value = (res.configs?.[0]?.value || '').split(',');
            if (value.includes(mobile)) {
                this.isPlanning = true;
                sessionStorage.setItem('isPlanning', true);
            } else {
                sessionStorage.setItem('isPlanning', '');
            }
        },
        // 获取列表
        async getList(flag) {
            if (!flag) this.dataListLoading = true;
            const query = {
                size: this.pagination.pageSize,
                page: this.pagination.current,
                sort: 'create_time__DESC'
            };
            // let customerCode = null;
            // if (getAppClientCode('appClientCode') === 'otms') {
            //     const data = await getConfig({
            //         appId: '1004',
            //         keys: ['zuwang.OTMS.data.access']
            //     });

            //     const value = (data.configs?.[0]?.value || '').split(',');
            //     customerCode = value && value.length ? JSON.parse(value[0]) : null;
            // }
            try {
                console.log(2222, this.$store.state.user.tenantId); // getAppClientCode('appClientCode') === 'otms'
                const res = await getInboundPlanPage(
                    {
                        ...this.queryForm,
                        customerCode: this.$store.state.user.tenantId
                    },
                    query
                );
                this.dataList = res.records;
                this.dataList.forEach((v) => {
                    v.exportLoading = false;
                });
                this.pagination.total = res.total;
                this.pagination.pageSize = res.size;
                this.pagination.current = res.page;
                this.dataListLoading = false;
            } catch {
                this.dataListLoading = false;
            }
        },
        handleTimeChange(value) {
            if (!value.length) {
                const { startCreateTime, endCreateTime, ...restParmas } = this.queryForm;
                this.queryForm = {
                    ...restParmas
                };
                this.toSearch();
            }
        },
        handleCancel() {
            if (this.isIfame) {
                this.toSearch();
            } else {
                this.$router.push('/task');
            }
        },
        handleOk(value) {
            const [start, end] = value;
            this.queryForm.startCreateTime = start;
            this.queryForm.endCreateTime = end;
            this.toSearch();
        },
        toSearch() {
            this.pagination.current = 1;
            this.getList();
        },
        handleReset() {
            this.queryForm = {};
            this.createTime = [];
            this.toSearch();
        },
        async downLoad(record) {
            console.log(444, record);
            this.exportLoading = true;
            await https({
                data: {
                    planCode: record.planCode,
                    planName: record.planName,
                    url: record.fileUrl
                },
                url: '/plan_msg/export',
                service: 'SMART_WIRUNG_SERVER',
                name: `${record.planName}排线`,
                type: 'xlsx'
            });
            setTimeout(() => {
                this.exportLoading = false;
            }, 1000);
        },
        toDetail(record) {
            this.selectedPlan = record;
            this.selectedPlanCode = record.planCode;
            this.showDetails = true;
        },
        // 删除
        toDelete(record) {
            const that = this;
            this.$confirm({
                title: '确认删除该计划单排线记录？',
                icon: () =>
                    this.$createElement('a-icon', {
                        props: {
                            type: 'info-circle',
                            theme: 'filled'
                        }
                    }),
                onOk() {
                    return new Promise((resolve) => {
                        planLineDelete({
                            planCodes: [record.planCode]
                        }).then((res) => {
                            console.log(res);
                            that.getList();
                            resolve();
                        });
                    });
                }
            });
        },
        // 导入
        addTemplate() {
            this.$refs.importPlan.show();
        },
        // 分页信息切换
        tableChange(pagination) {
            let { current } = pagination;
            if (pagination.pageSize !== this.pagination.pageSize) {
                current = 1;
            }
            this.pagination = {
                ...pagination,
                current
            };
            this.getList();
        },
        toEdit(record) {
            const planEditHistory = JSON.parse(localStorage.getItem('planEditHistory') || '{}');
            if (planEditHistory[record.id]) {
                this.$refs.editConfirm.show(record, planEditHistory);
            } else {
                this.$refs.editPlan.show(record, planEditHistory);
            }
        },
        changeEdit(record, planEditHistory) {
            this.$refs.editPlan.show(record, planEditHistory);
        },
        toHistory(record) {
            this.$refs.planHistory.show(record);
        },
        toApply(record) {
            this.$refs.applyConfirm.openModal(record);
        },
        toDiffInCost(record) {
            this.$refs.diffInCostConfirm.openModal(record);
        },
        async toBeconfirm(row) {
            try {
                await statusToBeConfirmed({ planCode: row.planCode });
                this.$message.success('变更成功');
                this.getList();
            } catch {
                console.log('变更失败');
            }
        },
        substring(str, len) {
            if (!str) return '';
            return str.length > len ? `${str.substr(0, len)}...` : str;
        },
        // 创建三种类型审批结果
        createApproveResult(msgs, index) {
            const batchMsg = msgs.find((item) => item.approveType === index);
            if (batchMsg) return batchMsg.content;
            return '';
        }
    }
};
</script>

<style lang="less" scoped>
.smart-wiring-list {
    .line {
        margin: 0 24px;
        background: #d9dbde;
        width: calc(100% - 48px);
        min-width: calc(100% - 48px);
    }
    .goods-table {
        margin-top: 24px;
    }
    .action-btn {
        color: #06b880;
        cursor: pointer;
        &::after {
            content: '';
            width: 1px;
            height: 12px;
            background: #dcdee0;
            margin: 0 8px;
            display: inline-block;
        }
    }
    .action-btn-dis {
        opacity: 0.5;
        color: #214b3e;
        cursor: not-allowed;
        &::after {
            content: '';
            width: 1px;
            height: 12px;
            background: #dcdee0;
            margin: 0 8px;
            display: inline-block;
        }
    }
    .action-btn-dis:last-child::after {
        display: none;
    }
    .action-btn:last-child::after {
        display: none;
    }
    .delete_btn {
        color: #969799;
    }
    .search-form {
        display: flex;
        align-items: center;
    }
    .formTitle {
        display: inline-block;
        text-align: right;
        width: 100%;
        line-height: 32px;
        padding-right: 6px;
    }
    .form-btn {
        /deep/ .ant-btn {
            margin-right: 12px;
        }
    }
    .create-plus {
        img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
        }
    }
    .plan-name {
        color: #06b880;
        cursor: pointer;
    }
}
.wiring_form {
    /deep/.ant-form-item-label label {
        color: #606266;
    }
}
.marRight16 {
    margin-right: 16px;
}
.default {
    display: flex;
    align-items: center;
    cursor: pointer;
    &::before {
        content: '';
        width: 6px;
        height: 6px;
        display: inline-block;
        background: #ebedf0;
        border-radius: 50%;
        margin-right: 4px;
    }
}

.success {
    color: #06b880;
    &::before {
        background: #06b880;
    }
}

.await::before {
    background: #fb9432;
}
.danger::before {
    background: #f5222f;
}
</style>
